import Raven from 'raven-js';
export const getErrorIs404NotFound = error => {
  return error.message.includes('404');
};
const getErrorIsAborted = error => {
  const message = error.message.toLowerCase();
  return message.includes('failed with status 0') || message.includes('request aborted');
};
export const reportErrorToRaven = (error, customMessage) => {
  if (!getErrorIsAborted(error)) {
    Raven.captureException(new Error(`ui-brand-identity-lib: ${customMessage}`, {
      cause: error
    }));
  }
};